export default __webpack_public_path__ + "static/media/house-5.db00993f.jpg";